<template>
  <q-btn @click="handleContactSupport" outline>{{ $t('contact_support') }}</q-btn>
</template>

<script>
  export default {
    methods: {
      handleContactSupport () {
        window.open('https://likvi.de/support')
      }
    }
  }
</script>
